import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { insideItems } from '../data/gallery';
import { VISUAL_IMAGE, VISUAL_IMAGE_ALT } from '../data/offer';
const imagine = ['Imagine explaining the layers of a tooth — enamel, dentin, pulp, cementum and PDL — with one clear cross-section.', 'Walking students through a Class I preparation step by step.', 'Showing normal radiographic landmarks next to the findings students tend to confuse with pathology.', 'Comparing a correct and an incorrect probe angle at a glance.', 'And connecting every technique to real patient care in the clinic.'];
export function VisualSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-332" data-mp="3l8inra2m2zpe">
      <div className="max-w-5xl mx-auto" data-id="element-333" data-mp="3l9a8tqyl1f1f">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid md:grid-cols-[1fr_1.4fr] gap-8 md:gap-12 items-start" data-id="element-334" data-mp="36bror1wunq0b">
          <div data-id="element-335" data-mp="9sr5d9vt3shz">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-5 text-[#0F4C5C] uppercase" data-id="element-336" data-mp="9tacrwntyyhr">
              See What You&apos;re Teaching
            </h2>
            <p className="text-xl font-semibold text-[#0F4C5C] mb-1" data-id="element-337" data-mp="npxlsxt25f41">Dentistry Is Hard to Explain With Words.</p>
            <p className="text-xl font-semibold text-[#0B7A7A] mb-5" data-id="element-338" data-mp="3s68iylb7unkd">
              Your Teaching Materials Shouldn&apos;t Be.
            </p>
            <div className="space-y-3 text-slate-700 leading-relaxed" data-id="element-339" data-mp="3n8or2illic9y">
              <p data-id="element-340" data-mp="4txnz6defhcj">{imagine.join(' ')}</p>
              <p className="font-semibold text-[#0F4C5C]" data-id="element-341" data-mp="4uz5ntox7238">
                That&apos;s the advantage of a 100% visual training system.
              </p>
              <p data-id="element-342" data-mp="38hzdxaokqn3g">
                <span className="font-semibold text-[#0A6464]" data-id="element-343" data-mp="38hfwdv2u60py">DENTAL INSTRUCTOR ATLAS</span> is built around
                illustrations, labeled diagrams, clinical sequences, numbered breakdowns, ❌/✅ comparisons,
                teaching cues, drills and quick checks.
              </p>
            </div>
          </div>

          <div className="bg-[#F2F7F8] border border-slate-200 rounded-2xl p-6" data-id="element-344" data-mp="1cdrzvzb6cqjb">
            <p className="text-sm font-bold text-[#0A6464] uppercase tracking-wider mb-4" data-id="element-345" data-mp="1h74dzfi89ext">
              Inside you’ll find:
            </p>
            <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-346" data-mp="1m70fn83gcua7">
              {insideItems.map(item => <li key={item} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-347" data-mp="tgifofy0z910">
                  <CheckCircle2 size={16} className="text-[#0B7A7A] shrink-0 mt-0.5" data-id="element-348" data-mp="tibl5rwwjn7f" />
                  <span data-id="element-349" data-mp="yhoaqkf5r8dp">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} src={VISUAL_IMAGE} alt={VISUAL_IMAGE_ALT} loading="lazy" className="w-full max-w-2xl h-auto mx-auto mt-12 rounded-2xl border border-slate-200 shadow-lg shadow-[#0F4C5C]/10" data-id="element-350" data-mp="29v0gj0uha12i" />

        <p className="text-center text-2xl md:text-4xl font-extrabold tracking-tight text-[#0F4C5C] mt-14" data-id="element-351" data-mp="3pl13ivo9luth">
          <span className="text-[#0B7A7A]" data-id="element-352" data-mp="3km6lhvy4gaaf">100% VISUAL.</span> PRACTICAL. PROFESSIONAL.{' '}
          <span className="bg-[#0F4C5C] text-white px-2 box-decoration-clone" data-id="element-353" data-mp="3foy3bvcz4696">BUILT TO TEACH.</span>
        </p>
      </div>
    </section>;
}